import type { MisconceptionDefinition } from '../types'

export const euHoofdstedenMisconceptions: MisconceptionDefinition[] = [
  // EU hoofdsteden detail en NL buurland/windstreken
  {
    id: 'topo.edinburgh-vk-verward',
    label: 'Verwart Edinburgh met VK-hoofdstad',
    module: 'Topo',
    description:
      'Leerling verwart Edinburgh (Schotland) met de hoofdstad van het Verenigd Koninkrijk.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.grote-stad-is-hoofdstad',
    label: 'Denkt grootste stad = hoofdstad',
    module: 'Topo',
    description:
      'Leerling denkt onterecht dat de grootste of bekendste stad altijd de hoofdstad is.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.dublin-vk-verward',
    label: 'Verwart Dublin met VK',
    module: 'Topo',
    description:
      'Leerling verwart Dublin (Ierland) met het Verenigd Koninkrijk.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.thessaloniki-griekenland',
    label: 'Kiest op-een-na-grootste stad',
    module: 'Topo',
    description:
      'Leerling kiest een andere grote stad in plaats van de hoofdstad.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.kreta-als-stad',
    label: 'Verwart eiland met stad',
    module: 'Topo',
    description:
      'Leerling kiest een eiland (bijv. Kreta) in plaats van een stad.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.istanbul-griekenland',
    label: 'Verwart Istanbul met Griekenland',
    module: 'Topo',
    description:
      'Leerling plaatst Istanbul in Griekenland in plaats van Turkije.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.scandinavie-oslo-zweden',
    label: 'Verwart Oslo met Zweden',
    module: 'Topo',
    description:
      'Leerling verwart de hoofdstad van Noorwegen met die van Zweden.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.scandinavie-helsinki-zweden',
    label: 'Verwart Helsinki met Zweden',
    module: 'Topo',
    description:
      'Leerling verwart de hoofdstad van Finland met die van Zweden.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.scandinavie-kopenhagen-zweden',
    label: 'Verwart Kopenhagen met Zweden',
    module: 'Topo',
    description:
      'Leerling verwart de hoofdstad van Denemarken met die van Zweden.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.niet-vraag-verkeerd-gelezen',
    label: 'Leest NIET-vraag verkeerd',
    module: 'Topo',
    description:
      'Leerling leest over het woordje NIET heen en kiest de hoofdstad.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.niet-vraag-berlijn',
    label: 'Leest NIET-vraag verkeerd (Berlijn)',
    module: 'Topo',
    description: 'Leerling leest over het woordje NIET heen en kiest Berlijn.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.niet-vraag-rome',
    label: 'Leest NIET-vraag verkeerd (Rome)',
    module: 'Topo',
    description: 'Leerling leest over het woordje NIET heen en kiest Rome.',
    typicalFamilies: ['TOPO-EU-HOOFDST'],
  },
  {
    id: 'topo.buurland-via-buurland',
    label: 'Verwart buurland van buurland met buurland',
    module: 'Topo',
    description:
      'Leerling denkt dat een land dat aan een buurland grenst, ook een direct buurland is.',
    typicalFamilies: ['TOPO-NL-BUURLANDEN'],
  },
  {
    id: 'topo.windstreken-omgedraaid',
    label: 'Windstreken omgedraaid',
    module: 'Topo',
    description: 'Leerling verwart de windstreken (bijv. oost met west).',
    typicalFamilies: ['TOPO-NL-BUURLANDEN'],
  },
  {
    id: 'topo.land-grootte-verward',
    label: 'Grootte van landen verward',
    module: 'Topo',
    description: 'Leerling schat de relatieve grootte van landen verkeerd in.',
    typicalFamilies: ['TOPO-NL-BUURLANDEN'],
  },
]
